<template>
  <div class="serve-manage">
    <el-card shadow="never" class="serve-card">
      <!-- 待上菜区域 -->
        <template #header>
          <h3 class="section-title">待上菜</h3>
        </template>
        
        <div v-if="allOrderStore.orders.length === 0" class="empty-tip">
          <el-empty description="暂无待上菜菜品" :image-size="100" />
        </div>
        <el-row :gutter="16">
          <el-col
            v-for="item in allOrderStore.orders"
            :key="item.id"
            :xs="24"
            :sm="12"
            :md="8"
            :lg="6"
          >
            <el-card class="serve-item-card" shadow="hover" :body-style="{ padding: '12px' }">
              <div class="serve-item">
                <!-- 卡片头部：菜名和总份数 -->
                <div class="serve-header">
                  <div>
                    <span class="serve-dish-name">{{ item.name }}</span>
                    <el-tag class="unread-tag" v-if="unreadCount(item.dishId) > 0" @click="clearUnreadList(item.dishId)">
                      {{unreadCount(item.dishId)}}
                    </el-tag>
                  </div>
                  <el-tag type="danger" size="small">{{ item.totalQuantity }}份</el-tag>
                </div>

                <!-- 各桌详情区域 -->
                <div class="serve-details">
                  <div
                    v-for="(detail, index) in item.tableQuantityList"
                    :key="index"
                    class="detail-row"
                  >
                    <span class="detail-table">{{ detail.tableNo }}桌</span>
                    <span class="detail-quantity">x{{ detail.quantity }}</span>
                    <span class="detail-time">{{ tzDayjs.formatTime(detail.orderTime) }}</span>
                    <el-button
                      type="primary"
                      size="small"
                      class="detail-button"
                      @click="updateServed(item, detail)"
                    >
                      上菜
                    </el-button>
                  </div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>

    </el-card>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useAllOrderStore } from '@/stores/admin/allOrderStore'
import tzDayjs from '@/utils/dayjs'
import sseService from '@/utils/sseService'
import speakService from '@/utils/speakService'

const allOrderStore = useAllOrderStore()
const unreadList = ref([])

const updateServed = async (dish, detail) => {
  ElMessageBox.confirm(`确认菜品“${dish.name}x${detail.quantity}”在${detail.tableNo}桌已上菜？`, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'info'
  }).then(async () => {
    await allOrderStore.updateServed({dishId : dish.dishId, orderId : detail.orderId})
    speakService.speak(`${detail.tableNo}桌的${detail.quantity}份${dish.name}已上菜`)
    ElMessage.success(`${detail.tableNo}桌的${detail.quantity}份${dish.name}已上菜`)
  }).catch(() => {})
}

const sseCallback = async (e) => {
  console.log('before getAllorder')
  await allOrderStore.getAllOrders()
  console.log('after getAllorder')
  if(e.data){
    const order = JSON.parse(e.data)
    if(order.type === 'add'){
      // 新订单的场合
      order.data.forEach(o => {
        unreadList.value.push({dishId : o.dishId, quantity : o.quantity})
      });
      console.log(unreadList.value,'before speak')
      speakService.speak('有新订单，请注意查收！')
      console.log('after speak')
    } else {
      // 有退订的场合 && 没有被上菜的情况
      if(!order.isServed){
        console.log('before speak')
        speakService.speak(`${order.dishName}被取消${order.cancelQuantity}份，请确认！`)
        console.log('after speak')
      }
    }
  }
}

const unreadCount = (dishId) => {
  return unreadList.value.filter(dish => dish.dishId == dishId).reduce((total, dish) => total + dish.quantity, 0)
}

const clearUnreadList = (dishId) => {
  unreadList.value =  unreadList.value.filter(dish => dish.dishId != dishId)
}

// 加载数据
onMounted(async () => {
  await allOrderStore.getAllOrders()
  // order更新监听事件追加
  sseService.on('order-updated', (e) => {
    sseCallback(e)
  })
})

onUnmounted(() => {
  sseService.off('order-updated')
})
</script>

<style scoped>
.serve-manage {
  width: 100%;
}

.serve-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 0px;
  padding-left: 12px;
  border-left: 4px solid #409eff;
  margin-top: 0px;
}

.empty-tip {
  text-align: center;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
}

.serve-item-card {
  border-radius: 8px;
  transition: transform 0.2s, box-shadow 0.2s;
  margin-bottom: 16px;
}

.serve-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.serve-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.serve-dish-name {
  font-size: 16px;
  font-weight: 600;
  color: #409eff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 各桌详情区域 */
.serve-details {
  display: flex;
  flex-direction: column;
  gap: 6px;
  background-color: #f8f9fa;
  border-radius: 6px;
  padding: 8px;
}

.detail-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
}

.detail-table {
  width: 60px;
  font-weight: 500;
  color: #333;
}

.detail-quantity {
  width: 40px;
  text-align: center;
  color: #666;
}

.detail-time {
  flex: 1;
  text-align: center;
  color: #888;
  font-size: 12px;
}

.detail-button {
  width: 50px;
  height: 24px;
  padding: 0 4px;
  font-size: 12px;
}

.serve-header > div {
  position: relative;
  display: flex;
  align-items: center;
}

/* 未读气泡样式 */
.unread-tag {
  position: absolute !important;
  top: -8px;
  right: -2px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  background-color: #ff6b6b !important;  /* 红色背景 */
  color: white !important;
  border-radius: 50% !important;
  line-height: 18px;
  font-size: 12px;
  text-align: center;
  border: 1px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 10;
  /* 覆盖 Element Plus 默认样式 */
  border: none !important;
  cursor: pointer;
}

/* 可选：调整菜名右边距，防止被气泡遮挡（如果菜名太长） */
.serve-dish-name {
  margin-right: 20px;  /* 根据气泡大小调整 */
}
</style>